"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileName = void 0;
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const extensions = {
    'audio/aac': '.aac',
    'application/x-abiword': '.bin',
    'application/octet-stream': '.arc',
    'video/x-msvideo': '.avi',
    'application/vnd.amazon.ebook': '.azw',
    'application/x-bzip': '.bz',
    'application/x-bzip2': '.bz2',
    'application/x-csh': '.csh',
    'text/css': '.css',
    'text/csv': '.csv',
    'application/msword': '.doc',
    'application/epub+zip': '.epub',
    'image/gif': '.gif',
    'text/html': '.html',
    'image/x-icon': '.ico',
    'text/calendar': '.ics',
    'application/java-archive': '.jar',
    'image/jpeg': '.jpeg',
    'application/javascript': '.js',
    'application/json': '.json',
    'audio/midi': '.midi',
    'video/mpeg': '.mpeg',
    'application/vnd.apple.installer+xml': '.mpkg',
    'application/vnd.oasis.opendocument.presentation': '.odp',
    'application/vnd.oasis.opendocument.spreadsheet': '.ods',
    'application/vnd.oasis.opendocument.text': '.odt',
    'audio/ogg': '.oga',
    'video/ogg': '.ogv',
    'application/ogg': '.ogx',
    'application/pdf': '.pdf',
    'application/vnd.ms-powerpoint': '.ppt',
    'application/x-rar-compressed': '.rar',
    'application/rtf': '.rtf',
    'application/x-sh': '.sh',
    'image/svg+xml': '.svg',
    'application/x-shockwave-flash': '.swf',
    'application/x-tar': '.tar',
    'image/tiff': '.tif',
    'font/ttf': '.ttf',
    'application/vnd.visio': '.vsd',
    'audio/x-wav': '.wav',
    'audio/webm': '.weba',
    'video/webm': '.webm',
    'image/webp': '.webp',
    'font/woff': '.woff',
    'font/woff2': '.woff2',
    'application/xhtml+xml': '.xhtml',
    'application/vnd.ms-excel': '.xls',
    'application/xml': '.xml',
    'application/vnd.mozilla.xul+xml': '.xul',
    'application/zip': '.zip',
    'video/3gpp': '.3gp',
    'video/3gpp2': '.3g2',
    'application/x-7z-compressed': '.7z',
    'text/plain': '.txt',
    'application/postscript': '.ai',
    'application/vnd.ms-fontobject': '.eot',
    'audio/mpeg': '.mp3',
    'video/mp4': '.mp4',
    'font/otf': '.otf',
    'image/png': '.png',
    'application/typescript': '.ts',
};
const getFileName = (url, contentType) => {
    let extension = extensions[`${contentType}`] || url.split('.').pop();
    if (extension && extension.includes('?')) {
        const [splitExtension] = (extension.split('?') || []);
        extension = splitExtension;
    }
    const isValidExtension = extension && /^[.][A-Za-z0-9]+$/.test(extension);
    const date = new Date();
    const fileName = `file_${Math.floor(date.getTime() + date.getSeconds() / 2)}`;
    return isValidExtension ? `${fileName}${extension}` : fileName;
};
exports.getFileName = getFileName;
const isUrlValid = /^[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
const buildCallableDownloadFile = (args) => async ({ entryVars: { url, }, callbacks, functionId, executeProcesses, }) => {
    try {
        if (!(0, valueIsString_1.default)(url) || !isUrlValid.test(url)) {
            executeProcesses(functionId, callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError, 'Invalid url');
            return;
        }
        const uri = await args.onDownloadFile(url);
        executeProcesses(functionId, callbacks === null || callbacks === void 0 ? void 0 : callbacks.onSucess, uri);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeProcesses(functionId, callbacks === null || callbacks === void 0 ? void 0 : callbacks.onError, errorMessage);
    }
};
exports.default = buildCallableDownloadFile;
